<div class="h1 content-title text-center p-3">E-ügyintézés</div>

<div class="content my-5 col-lg-10 mx-auto px-5">
  <div class="the_content_wrapper">
    <p>Tisztelt Ügyfeleink!</p>
    <br />
    <p>
      Tájékoztatom Önöket, hogy az elektronikus ügyintézés és bizalmi
      szolgáltatások általános szabályairól szóló 2015.évi CCXXII. törvény
      alapján 2018. január 1-jétől lehetőségük van ügyeiket a Tatai Közös
      Önkormányzati Hivatal Dunaszentmiklósi Kirendeltségén elektronikusan
      intézni.
    </p>
    <br />
    <p>Felhívom figyelmüket, hogy a törvény alapján az ügyfélként eljáró</p>
    <br />
    <ul>
      <li>
        gazdálkodó szervezet, valamint az ügyfél jogi képviselője köteles az
        elektronikus ügyintézésre.
      </li>
      <li>
        természetes személy ügyfeleink részére a törvény jogosultságot biztosít
        az elektronikus ügyintézésre. Eszerint lehetőségük van ügyeik intézése
        során ügyintézési cselekményeiket elektronikus úton végezni, valamint
        nyilatkozataikat elektronikus úton megtenni. Az elektronikus ügyintézés
        feltétele az ügyfélkapus jogosultsággal való rendelkezés. (<a
          href="https://magyarorszag.hu/"
          >https://magyarorszag.hu/</a
        >)
      </li>
    </ul>
    <br />
    <p>
      Hivatalunkban lehetőség van az E-önkormányzat (<a
        href="https://ohp-20.asp.lgov.hu/"
        >https://ohp-20.asp.lgov.hu/</a
      >) portálon keresztül közvetlenül is ügyet indítani az alábbi
      ügytípusokban (<u>adóügyek,</u> kereskedelmi ügyek,
      szálláshelyszolgáltatás, valamint anyakönyvi kivonat iránti kérelem).
    </p>
    <p>
      Az E-önkormányzat portál bárki számára elérhető, egyes funkciók szabadon
      használhatók, más funkciók azonban bejelentkezéshez kötöttek.
    </p>
    <br />
    <p>Bejelentkezés nélkül igénybe vehető funkciók:</p>
    <ul>
      <li>Önkormányzat-kereső</li>
      <li>Űrlapok kitöltése beküldés nélkül</li>
    </ul>
    <br />
    <p>Bejelentkezéshez kötött (online) funkciók:</p>
    <ul>
      <li>Elektronikus űrlap beküldése</li>
      <li>Mentett űrlapok elérése és megnyitása</li>
      <li>Ügykövetés</li>
      <li>Adóegyenleg-lekérdezés</li>
      <li>Adóbevallási információk lekérdezése</li>
      <li>Saját önkormányzatok listája</li>
    </ul>
    <br />
    <p>
      Az E-önkormányzat portálra történő belépést követően Dunaszentmiklós
      Község Önkormányzatát kell megjelölni, azon belül választható ki az
      intézni kívánt ügycsoport.
    </p>
    <p class="text-center">
      <a href="https://ohp-20.asp.lgov.hu/nyitolap"
        ><img
          class="alignnone size-medium e-img aligncenter"
          src="./assets/imgs/Eugyintezes.jpg"
          alt=""
          width="400"
      /></a>
    </p>
    <br />
    <br />
    <p>
      Az online ügyintézéshez a felhasználónak rendelkeznie kell elektronikus
      azonosításra alkalmas azonosítóval (ügyfélkapus regisztrációval,
      e-személyivel, vagy részleges kódú telefonos azonosítással), értesítési
      tárhellyel, valamint nem lehet tiltott az Elektronikus ügyintézésre
      vonatkozó alap rendelkezése a Rendelkezési Nyilvántartásban
      (https://rendelkezes.gov.hu/). Ezek mellett az első belépéskor a KAÜ1
      azonosítást követően el kell fogadnia az Általános Szerződési Feltételeket
      (továbbiakban: ÁSZF).
    </p>
    <br />
    <p>
      Hivatalunkban, egyéb ügyekben, az általános elektronikus ügyintézés az
      E-papír szolgáltatás keretében történik (https://epapir.gov.hu/).
      Amennyiben Dunaszentmiklós Község Önkormányzatának vagy a Tatai Közös
      Önkormányzati Hivatal Dunaszentmiklósi Kirendeltségének kívánnak beadványt
      benyújtani, a fent megjelölt E-papír felületen az ügyfélkapus
      bejelentkezést követően a Témacsoport és az Ügytípus kiválasztása után
      Dunaszentmiklós Község Önkormányzat címzettet kell kiválasztani
    </p>
    <br />
    <p>
      Helyi adó befizetése esetén a közlemény rovatban a féléves értesítésen
      szereplő azonosító számot kell feltüntetni. A helyi adó befizetésére
      szolgáló számlaszámokról a
      www.dunaszentmiklos.hu/onkormanyzat/#kirendeltseg oldalon tájékozódhat.
    </p>
    <br />
    <p>
      Illetékfizetési kötelezettség esetén természetes személy ügyfeleink
      jogosultak az ügyintézésért fizetendő eljárási illetéket elektronikus úton
      megfizetni. Gazdálkodó szervezet ügyfél az önkormányzat előtti ügye során
      köteles az illetéket elektronikus úton megfizetni.
    </p>
    <p>
      Az eljárási illeték Dunaszentmiklós Község Önkormányzat Takarékbanknál
      vezetett 63200236-11047832 számú számlájára fizethető meg. Kérjük, hogy az
      átutalási megbízás közlemény rovatában szíveskedjen az ügyfél nevét, az
      ügy típusát, valamint – amennyiben az rendelkezésére áll – az ügy
      iktatószámát feltüntetni.
    </p>
    <br />
    <br />
    <br />
    <p>László Ferenc</p>
    <p>kirendeltség-vezető</p>
  </div>
</div>
